const companyTypeB = {
    Agriculture: [
        { name: 'Animal Production' },
        { name: 'Crop Production' },
        { name: 'Forestry and Logging' },
        { name: 'Fishing, Hunting & Trapping' },
        { name: 'Support Activities For Agriculture' }
    ],
    'Mining, Quarrying and Oil & Gas Industry': [{ name: 'Oil & Gas Extraction' }, { name: 'Mining' }],
    Construction: [
        { name: 'Construction of Buildings' },
        { name: 'Heavy & Civil Engineering Construction' },
        { name: 'Specialty Trade Contractors' }
    ],
    Manufacturing: [
        { name: 'Food Manufacturing' },
        { name: 'Beverages Manufacturing' },
        { name: 'Tobacco Manufacturing' },
        { name: 'Textile Mills' },
        { name: 'Textile Product Mills' },
        { name: 'Apparel Manufacturing' },
        { name: 'Leather & Allied Product Manufacturing' },
        { name: 'Wood Product Manufacturing' },
        { name: 'Paper Manufacturing' },
        { name: 'Printing and Related Support Activities' },
        { name: 'Chemicals Manufacturing' },
        { name: 'Plastics & Rubber Products Manufacturing' },
        { name: 'Non-metallic Mineral Product Manufacturing' },
        { name: 'Primary Metal Manufacturing' },
        { name: 'Machinery Manufacturing' },
        { name: 'Computer & Electronic Products Manufacturing' },
        { name: 'Electrical Equipment, Appliance & Component' },
        { name: 'Transportation Equipment Manufacturer' },
        { name: 'Furniture & Related Products Manufacturer' },
        { name: 'Medical Equipment Manufacturing' },
        { name: 'All Other Manufacturing' }
    ],
    'Wholesale Trade': [
        { name: 'Durable Goods Wholesalers' },
        { name: 'Non-durable Goods Wholesalers' },
        { name: 'Wholesale Brokers & Agents' }
    ],
    'Retail Trade (Nonfood)': [
        { name: 'Motor Vehicles & Parts Dealers' },
        { name: 'Furniture & Home Furnishing Stores' },
        { name: 'Electronics & Appliance Dealers' },
        { name: 'Building Materials Dealers & Suppliers' },
        { name: 'Health & Personal Care Products Dealers' },
        { name: 'Gas Re-fillers & Petrol Stations' },
        { name: 'Clothing, Accessories & Luggage Dealers' },
        { name: 'Sporting Goods Retailers' },
        { name: 'Hobby & Music Retailers' },
        { name: 'General Merchandise (Stores)' },
        { name: 'General Merchandise (Online)' }
    ],
    'Retail Trade ( Food)': [{ name: 'Refrigerated & Frozen Foods' }, { name: 'Shelf Groceries & Provisions' }],
    Transportation: [
        { name: 'Air Transportation' },
        { name: 'Rail Transportation' },
        { name: 'Water Transportation' },
        { name: 'Truck Transportation' },
        { name: 'Transit & Road Passenger Transportation' },
        { name: 'Scenic & Sightseeing Transportation' },
        { name: 'Support Activities For Transportation' },
        { name: 'Postal Service' },
        { name: 'Warehousing & Storage' },
        { name: 'Pipeline Transportation' }
    ],
    Utilities: [{ name: 'Electricity Provision' }, { name: 'Natural Gas Distribution' }, { name: 'Water, Sewage & Other Systems' }],
    Information: [
        { name: 'Publishing Industries' },
        { name: 'Sound & Movie Production' },
        { name: 'Broadcasting' },
        { name: 'Internet Publishing & Broadcasting' },
        { name: 'Telecommunications' },
        { name: 'Data Processing & Hosting Service' },
        { name: 'Information Websites' }
    ],
    'Financial & Insurance': [
        { name: 'Monetary Authorities - Central Bank' },
        { name: 'Credit Intermediator Services' },
        { name: 'Security Contracts/ Finacial Investments' },
        { name: 'Insurance Institutions' },
        { name: 'Funds & Trusts' }
    ],
    'Real  Estate & Rental Leasing': [
        { name: 'Real Estate' },
        { name: 'Rental & Leasing Service' },
        { name: 'Non-financial Asset Leasing' }
    ],
    'Professional & Business Services': [
        { name: 'Professional, Scientific & Tech. Services' },
        { name: 'Management of Companies & Enterprises' },
        { name: 'Administrative Support Services' },
        { name: 'Waste Management & Remediation Services' }
    ],
    'Healthcare & Social Assistance': [
        { name: 'Ambulatory Healthcare Services' },
        { name: 'Hospitals' },
        { name: 'Nursing & Residential Care' },
        { name: 'Social Assistance' },
        { name: 'Educational Support Services' }
    ],
    'Leisure & Hospitality': [
        { name: 'Performing Arts & Spectator Sports' },
        { name: 'Museums & Historical Sites' },
        { name: 'Amusement, Gambling & Betting Services' },
        { name: 'Accommodation Services' },
        { name: 'Food Services' },
        { name: 'Repair & Maintenance' },
        { name: 'Personal & Commercial Laundry Services' },
        { name: 'Personal Services' }
    ],
    'Religious & Social Advocacy Organizations': [
        { name: 'Religious Organizations' }
        // { name: 'Grantmaking & Giving Services' },
        // { name: 'Social Advocacy Organizations' },
        // { name: 'Civil & Social Organizations' }
    ],
    'Private Households Service Delivery': [{ name: 'Employment Agencies' }]
};

export default companyTypeB;
